// extracted by mini-css-extract-plugin
export default {"wrapper":"CategoriesTournamentsMenu_wrapper--s8l","title":"CategoriesTournamentsMenu_title--cM3"};